module.exports = __webpack_public_path__ + "img/showcase-partner-login.8b3cc865.webp";